
window.addEventListener(`DOMContentLoaded`, () => {
    const banners = document.querySelectorAll('.js-bpif-banner');

    if (banners.length) {
        const randomIndex = Math.floor(Math.random() * banners.length);
        banners[randomIndex].classList.add('active');
    }
})